export const validate = (values, rules) => {
    const errors = {};

    Object.keys(rules).forEach((field) => {
        const rule = rules[field];
        const value = (values[field] || "").toString().trim();

        // Required
        if (rule.required && !value) {
            errors[field] = `${rule.label} is required.`;
            return;
        }

        // Minimum Length
        if (rule.minLength && value.length < rule.minLength) {
            errors[field] = `${rule.label} must be at least ${rule.minLength} characters.`;
            return;
        }

        // Maximum Length
        if (rule.maxLength && value.length > rule.maxLength) {
            errors[field] = `${rule.label} must not exceed ${rule.maxLength} characters.`;
            return;
        }

        // Email
        if (
            rule.type === "email" &&
            value &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
        ) {
            errors[field] = "Please enter a valid email address.";
            return;
        }

        // Number
        if (rule.type === "number" && value && isNaN(value)) {
            errors[field] = `${rule.label} must be a number.`;
            return;
        }

        // Pattern
        if (rule.pattern && value && !rule.pattern.test(value)) {
            errors[field] = rule.message || `${rule.label} is invalid.`;
            return;
        }

        // Custom Validation
        if (rule.validator) {
            const result = rule.validator(value, values);

            if (result) {
                errors[field] = result;
            }
        }
    });

    return errors;
};

export const ErrorMessage = ({ error }) => {
    if (!error) return null;

    return (
        <p className="mt-1 text-sm text-red-500">
            {error}
        </p>
    );
};